/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/pause'
export default icon
